module.exports = "<span> {{datetime | localizedDate : selectedLanguage : format}} </span> \n";